// 🟦 THE UNIFIED SQUARE — every merchant's billboard unit. Lives on the DEALS BOARD wall,
// mirrors the POG STRIP universe. Unclaimed merchants get a starter Square + claim ribbon.
import { logoFor } from "@/lib/brandLogos";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const MerchantSquare = ({ b, onOpen }) => {
  const logo = logoFor(b, null, BACKEND_URL);
  return (
    <button data-testid={`well-square-${b.id}`} onClick={() => onOpen?.(b)}
      className="relative rounded-2xl overflow-hidden flex flex-col items-center justify-center aspect-[4/3] bg-slate-900/80 border border-slate-600/50 px-2 pb-4 text-center hover:border-sky-400/70 transition-colors">
      {logo ? (
        <span className="relative w-9 h-9 flex items-center justify-center">
          <span className="absolute font-heading font-black text-lg text-sky-300">{(b.name || "?").charAt(0).toUpperCase()}</span>
          <img src={logo} alt="" loading="lazy" className="relative w-9 h-9 object-contain rounded-md bg-white p-0.5 shadow"
            onError={(e) => { e.currentTarget.style.display = "none"; }} />
        </span>
      ) : (
        <span className="w-9 h-9 rounded-md bg-slate-800 flex items-center justify-center font-heading font-black text-lg text-sky-300">{(b.name || "?").charAt(0).toUpperCase()}</span>
      )}
      <p className="text-[9px] font-black text-slate-200 mt-1 leading-tight line-clamp-2 max-w-full">{b.name}</p>
      {(b.has_deals || b.ad_headline) && (
        <p className="text-[8px] font-black text-amber-300 truncate max-w-full">🔥 {b.ad_headline || "deals inside"}</p>
      )}
      <span role="button" data-testid={`square-run-${b.id}`} title="INSTANT POG RUN 🏃⚡"
        onClick={(e) => { e.stopPropagation(); window.dispatchEvent(new CustomEvent("airpog:instant-run", { detail: { b } })); }}
        className="absolute top-1 right-1 w-6 h-6 rounded-full bg-emerald-400/20 hover:bg-emerald-400/40 flex items-center justify-center text-[11px]">🏃</span>
      <span className="absolute bottom-0 inset-x-0 bg-emerald-500/15 border-t border-emerald-400/30 text-[7px] font-black tracking-widest text-emerald-300 py-0.5">CLAIM THIS SQUARE</span>
    </button>
  );
};
